export default __webpack_public_path__ + "static/media/ELECTIVES_COOKING_AND_BAKING.66c5754f.svg";